<template>
  <div>
    <el-dialog
      class="address_book_contain"
      lock-scroll
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$lang('从地址簿选择')"
      custom-class="jms-dialog MTAuto"
      :close-on-click-modal="false"
      :visible.sync="visible"
      @close="close"
      width="900px"
    >
      <div class="overflow">
        <div class="search">
          <el-input v-model="pageData.keyword" :placeholder="$lang('姓名/联系电话/地址')" class="input" @keyup.enter.native="search"> </el-input>
          <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="search">{{ $lang('查询') }}</el-button>
          <el-button v-if="pageType==='batchOrder'" type="primary" icon="iconfont iconxinzeng" class="h32" @click="addNew">{{ $lang('新增寄件地址') }}</el-button>
        </div>
        <JmsTable
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @size-change="sizeChange"
          @select-change="selectionChange"
          @row-click="currentRowChange"
          @current-change="currentChange"
        >
          <template slot="singleSelect" slot-scope="{ row }">
            <div v-if="current.id === row.id"><i class="iconfont iconchenggong"></i></div>
          </template>
        </JmsTable>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" :disabled="current.areaId ? false : true" @click="comfirm" class="h40 button_myself">{{ $lang('确定') }}</el-button>
      </div>
    </el-dialog>
    <Address v-model="addrFormVisible" @success="search" />
  </div>
</template>

<script>
import JmsTable from '@/components/jms-widget/jms-table'
import { RULES, phoneAndMobile, checkAddressFormat } from '@utils/rules'
import mixin from '@/mixins/mixin.js'
import { mapGetters } from 'vuex'
import { addressPage } from '@api/module/customer'
import Address from './Address'
export default {
  name: 'AddressBook',
  props: {
    value: {},
    spotType: {
      type: String,
      default: '',
    },
    selectType: {
      type: Number,
      default: 1,
    },
    pageType: {
      type: String,
      default: '',
    },
  },
  components: {
    JmsTable,
    Address,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: addressPage,
      },
      visible: false,
      addrFormVisible: false,
      isShowFirst: false,
      tableList: [],
      page: {
        // 分页配置
        current: 1,
        size: 20,
        total: 0,
      },
      loading: false,
      rules: {
        name: [RULES.requiredTrim],
        mobile: [RULES.required, { validator: phoneAndMobile }],
        local: [RULES.requiredSelect],
        detailedAddress: [RULES.required, { validator: checkAddressFormat }],
      },
      addrBook: true,
      smartSpot: false,
      pageData: {
        current: 1, // 当前页码
        size: 20, // 分页数量
        type: 1, // 1寄件2取件
        keyword: '', // 姓名/电话/地址
      },
      current: {
        areaId: '',
      },
    }
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val
      },
      deep: true,
    },
    selectType: {
      handler(val) {
        this.pageData.type = val
        this.current = {
          areaId: '',
        }
        this.addressPage(this.pageData) // 列表带分页
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    listOpt() {
      return {
        border: true,
        selection: false,
        menu: false,
        tableHeight: 490,
        currentRow: true,
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('姓名'),
            prop: 'name',
          },
          {
            label: this.$lang('联系电话'), //  扫描员
            prop: 'mobile',
            width: 120,
          },
          {
            label: this.$lang('州'),
            prop: 'provinceName',
          },
          {
            label: this.$lang('城市'),
            prop: 'cityName',
          },
          {
            label: this.$lang('乡镇'),
            prop: 'areaName',
          },
          {
            label: this.$lang('详细地址'),
            prop: 'detailedAddress',
            width: 300,
          },
          {
            label: this.$lang('地址2'),
            prop: 'detailedAddress2',
            width: 170,
          },
          {
            label: this.$lang('公司名称'),
            prop: 'companyName',
          },
          {
            label: this.$lang('手机区号'),
            prop: 'mobileAreaCode',
          },
          {
            label: this.$lang('邮箱'),
            prop: 'email',
          },
          {
            label: this.$lang('邮编'),
            prop: 'postalCode',
          },
          {
            prop: this.$lang('singleSelect'),
            width: 100,
            slot: true,
          },
        ],
      }
    },
  },
  methods: {
    search() {
      // 搜索
      this.addressPage(this.pageData) // 列表带分页
    },
    updateBtnStauts(addressData) {
      if (addressData) {
        this.current = addressData
      } else {
        this.current = {
          areaId: '',
        }
      }
    },
    initData() {
      this.disabled = true
    },
    async comfirm() {
      // 确定选择2
      // TODO 暂时先屏蔽
      this.$emit('single-row-select', this.current, this.selectType)
      this.visible = false
    },
    addNew() {
      // 新增地址-跳转
      this.addrFormVisible = true
    },
    close() {
      // 关 闭
      this.visible = false
      this.current = {
        areaId: '',
      }
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
    },
    getParams() {
      return { type: this.pageData.type, keyword: this.pageData.keyword }
    },
    // 单选-选中
    currentRowChange(val) {
      if (val) {
        this.disabled = false
        this.current = val
      }
    },
    // 单选操作（复选框）
    selectionChange(val) {
      this.selectedRows = val
    },
    async addressPage(reqData) {
      // 列表带分页
      const { code, data, msg } = await addressPage(reqData)
      if (code === 1) {
        this.tableList = data.records
        this.page.total = data.total
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.address_book_contain {
  .dialog-footer {
    .button_myself {
      min-width: 140px;
    }
  }
}
.search {
  height: 32px;
  line-height: 32px;
  margin-bottom: 16px;
  .input {
    width: 240px !important;
    margin-right: 24px;
  }
  .icon-search {
    display: inline-block;
    width: 20px;
    height: 32px;
    line-height: 32px;
  }
  .add {
    color: #e60012;
    .iconxinzeng {
      margin-right: 4px;
    }
  }
}
.form-title {
  font-size: 16px;
  font-weight: bold;
  i {
    margin-right: 7px;
  }
}

.iconchaxun:hover {
  color: #e60012;
}
</style>
<style lang="scss">
.MTAuto {
  .el-table {
    max-height: 430px;
  }
}
</style>
